import styled from "styled-components";
import { Box } from "@mui/material";

export const ContentContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: "32px",
  minHeight: "495px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "start",
  alignItems: "end",
}));

export const AddLevelButtonContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "100%",
  marginBottom: "150px",
  justifyContent: "end",
}));

export const ActionsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "end",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    width: "100%",
  },
}));
